/* eslint-disable no-process-env */
/**
 * See https://razzlejs.org/docs/environment-variables
 */

const isTrue = (t: string | boolean) => t === true || t === 'true'

/**
 * These variables are populated at runtime and are accessible for both server and client
 */
export const RuntimeConfigs = (process => {
  return {
    TRIBE_GQL_ENDPOINT: process.env.TRIBE_GQL_ENDPOINT,
    TRIBE_APP_DOMAIN: process.env.TRIBE_APP_DOMAIN,
    FORCED_NETWORK_DOMAIN: process.env.FORCED_NETWORK_DOMAIN,
    SSOS_CALLBACK_URL: process.env.SSOS_CALLBACK_URL,
    UNSPLASH_ACCESS_KEY: process.env.UNSPLASH_ACCESS_KEY,
    GIPHY_API_KEY: process.env.GIPHY_API_KEY,
    INTERCOM_APP_ID: process.env.INTERCOM_APP_ID,
    SNOWPLOW_COLLECTOR_ADDRESS: process.env.SNOWPLOW_COLLECTOR_ADDRESS,
    SNOWPLOW_ENABLE_PAGE_PING: isTrue(process.env.SNOWPLOW_ENABLE_PAGE_PING),
    SNOWPLOW_ENABLE_PAGE_VIEW: isTrue(process.env.SNOWPLOW_ENABLE_PAGE_VIEW),
    NODE_ENV: process.env.NODE_ENV,
    FULLSTORY_ORGANIZATION_ID: process.env.FULLSTORY_ORGANIZATION_ID,
    FULLSTORY_DEBUG_MODE: isTrue(process.env.FULLSTORY_DEBUG_MODE),
    RELEASE_CHANNEL: process.env.RELEASE_CHANNEL,
    SENTRY_DSN: process.env.SENTRY_DSN,
    MEDIA_BASE_URL: process.env.MEDIA_BASE_URL,
    OPTIMIZELY_SDK_KEY: process.env.OPTIMIZELY_SDK_KEY,
    CLIENT_LOG_LEVEL: process.env.CLIENT_LOG_LEVEL || 'info',
    SUPPORT_COMMUNITY_URL: process.env.SUPPORT_COMMUNITY_URL,
  }
})(typeof window !== 'undefined' ? window.process : process)

/**
 * These variables are populated at runtime and are only available to server
 */
export const ServerOnlyConfigs = {
  INTERCOM_VERIFICATION_SECRET: process.env.INTERCOM_VERIFICATION_SECRET,
  HOST: process.env.HOST || 'localhost',
  PORT: process.env.PORT || 5000,
  SSL_PORT: process.env.SSL_PORT || 443,
  SERVE_HTTPS: isTrue(process.env.SERVE_HTTPS),
  LOG_LEVEL: process.env.LOG_LEVEL || 'info',
  DEBUG_CONFIGS: isTrue(process.env.DEBUG_CONFIGS),
  TRIBE_GQL_PRIVATE_ENDPOINT:
    process.env.TRIBE_GQL_PRIVATE_ENDPOINT || process.env.TRIBE_GQL_ENDPOINT,
  IS_BETA: process.env.IS_BETA,
  BETA_SERVER: process.env.BETA_SERVER,
  SSR_ENABLED_NETWORKS: process.env.SSR_ENABLED_NETWORKS?.split(','),
  SUPPORT_COMMUNITY_JWT_TOKEN: process.env.SUPPORT_COMMUNITY_JWT_TOKEN,
  ALLOW_SSR_MODE_BY_COOKIE: process.env.ALLOW_SSR_MODE_BY_COOKIE === 'true',
}

/**
 * This variables will be inlined during build.
 * Keep in mind that variables should start with `RAZZLE_` to be inlined.
 * Variables listed in https://razzlejs.org/docs/environment-variables#build-time-variables
 * will also be inlined.
 */
export const StaticConfigs = {
  IS_PROD: process.env.NODE_ENV === 'production',
  NODE_ENV: process.env.NODE_ENV || 'production',
  APP_VERSION: process.env.RAZZLE_APP_VERSION || 'dev',
  RAZZLE_PUBLIC_DIR: process.env.RAZZLE_PUBLIC_DIR,
}

export const shouldDebugConfigs = () => {
  return typeof window === 'undefined' && isTrue(process.env.DEBUG_CONFIGS)
}
